var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "orderConsumptionTrend" },
    [
      ["1", "2"].includes(_vm.searchData.tag_type)
        ? _c("order-consume-business", {
            attrs: { is_total: _vm.is_total, searchData: _vm.searchData },
          })
        : _c("order-consume-details", {
            attrs: {
              orderId: _vm.orderId,
              searchData: _vm.searchData,
              activeNameDefault: _vm.activeNameDefault,
              detailActiveName: _vm.detailActiveName,
              entry: _vm.entry,
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }